import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";

export default class NavBar extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);
        scene.add.existing(this);

        this.scene = scene;

        this.spacer = 20;
        this.time = 60;
        this.score = 0;
		
        this.createNav();
    }

	createNav() {
        this.scoreCont = this.scene.add.container();
        this.timeCont = this.scene.add.container();
        this.add(this.scoreCont);
        this.add(this.timeCont);

        this.pauseBtn = ABCyaPhaser.Buttons.addSimpleButton(this.scene.mid.x*2 - 35 - this.spacer, -40, "pause_button", null, ()=>{
            this.pauseBtn.setEnabled(false);
            ABCyaPhaser.Audio.playOneShot("Click", this.scene);
            
            this.setClock("pause");
            this.scene.showPopup("paused");
        }, this).setEnabled(false);

        this.scorePanel = ABCyaPhaser.Images.addImage(0, 0, "score_display", this.scoreCont);
        this.scoreTxt = ABCyaPhaser.Text.addText(this.scorePanel.width/6, -3, 25, "0xFFFFFF", gameData.GAME_FONTS[0], String(this.score), this.scoreCont);

        this.timePanel = ABCyaPhaser.Images.addImage(0, 0, "timer_display", this.timeCont);
        this.timeTxt = ABCyaPhaser.Text.addText(this.timePanel.width/8, -3, 25, "0xFFFFFF", gameData.GAME_FONTS[0], String(this.time), this.timeCont);

        this.timeCont.setPosition(this.pauseBtn.x - this.timePanel.width/2 - this.pauseBtn.width/2 - this.spacer, this.pauseBtn.y);
        this.scoreCont.setPosition(this.scorePanel.width/2 + this.spacer, this.pauseBtn.y);

        ABCyaPhaser.Tweens.addTween(this, 1000, {y:this.pauseBtn.height + this.spacer}, Phaser.Math.Easing.Quadratic.Out, ()=>{
            this.setClock("countdown");
            this.pauseBtn.setEnabled(true);
        });
	};

    setScore(type){
        if(type == "+"){
            this.score++;
            gameData.WORDS_MADE++;

            this.scoreTxt.destroy();
            this.scoreTxt = null;

            this.scoreTxt = ABCyaPhaser.Text.addText(this.scorePanel.width/6, -3, 25, "0xFFFFFF", gameData.GAME_FONTS[0], String(this.score), this.scoreCont);
        }
        if(type == "-"){
            console.log("miss");
            gameData.WORDS_MISSED++;
        }
    };

    setClock(type){
        if(type == "countdown"){
            this.time--;

            if(!gameData.GAME_PAUSED){
                if(this.time == 55 || this.time == 45 ||this.time == 35 || this.time == 25 || this.time == 22 || this.time == 20 || this.time == 18 || this.time == 15 || this.time == 12 || this.time == 10){
                    this.scene.createRockets();
                }
            }

            if(this.time > 0){
                this.timeTxt.destroy();
                this.timeTxt = null;

                this.timeTxt = ABCyaPhaser.Text.addText(this.timePanel.width/8, -3, 25, "0xFFFFFF", gameData.GAME_FONTS[0], String(this.time), this.timeCont);

                this.timeTween = this.scene.time.delayedCall(1000, ()=>{this.setClock("countdown");});
            } else {
                console.log("GAME OVER");

                gameData.GAME_DONE = true;

                this.timeTxt.destroy();
                this.timeTxt = null;

                this.timeTxt = ABCyaPhaser.Text.addText(this.timePanel.width/8, -3, 25, "0xFFFFFF", gameData.GAME_FONTS[0], String(this.time), this.timeCont);

                this.timeTween.timeScale = 0;

                this.scene.showPopup("end");
                this.pauseBtn.setEnabled(false);
                ABCyaPhaser.Tweens.addTween(this, 1000, {y:-40}, Phaser.Math.Easing.Quadratic.Out);
            }
        }
        if(type == "pause"){
            this.timeTween.timeScale = 0;
        }
        if(type == "resume"){
            this.timeTween.timeScale = 1;
        }
    };
}